import React, { useEffect, useState } from "react";
import { BASE_URL, MEDIA_URL } from ".././config/url";
import DOMPurify from "dompurify";
import { RestfullApiService, RestfullApiServiceGet } from ".././config/service";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { decryptData, encryptData } from "../utils/storage";
import { useSelector } from "react-redux";
import PreLoader from "../utils/PreLoader";

function ViewTickets() {
  const [ticketDetails, setTicketDetails] = useState([]);
  const [isBibExpoAvail, setIsBibExpoAvail] = useState();
  const [bibExpoDeatials, setBibExpoDetails] = useState({});
  const [fetchingDetails, setFetchingDetails] = useState(false);
  const [dateAndTime, setDateAndTime] = useState([]);
  const [orgEmailId, setOrgEmailId] = useState("");
  const [eventId, setEventId] = useState("");
  const navigate = useNavigate();
  const { booking_id } = useParams();

  const sanitizeAndModifyHTML = (html) => {
    // Create a new div element to parse the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Modify the styles of all span elements
    const spans = tempDiv.querySelectorAll("span");
    spans.forEach((span) => {
      span.style.fontFamily = "Montserrat, sans-serif";
      span.style.fontFamily = "Inter, sans-serif";
      span.style.color = "#535B62";
      span.style.fontSize = "13px";
    });

    // Sanitize the modified HTML string
    return DOMPurify.sanitize(tempDiv.innerHTML);
  };

  const user = useSelector((state) => state.user.userProfile);
  // const user = JSON.parse(localStorage.getItem("userProf"));

  async function viewTicketHandle() {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "MyBookingDetails",
      Filter: decryptData(booking_id),
    };

    console.log("Request Data:", reqdata);

    try {
      setFetchingDetails(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/Profile_get"
      );
      console.log("API Response:", result);

      if (result) {
        setTicketDetails(result?.data?.Result.Table2);
        setIsBibExpoAvail(
          result?.data?.Result?.Table1[0].Is_BIB_Expo_Available
        );
        setEventId(encryptData(result?.data?.Result?.Table1[0].Event_Id));
        setBibExpoDetails(result?.data?.Result.Table2[0]);
        setOrgEmailId(result?.data?.Result.Table1[0]?.Org_Email);
        setDateAndTime(result?.data?.Result.Table3);

        console.log(result);
        return result;
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err);
    } finally {
      setFetchingDetails(false);
    }
  }

  const downloadTicket = async (Id) => {
    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "GetTicketToDownload",
    };

    try {
      const result = await RestfullApiServiceGet(
        reqdata,
        `participant/downloadticket?Tran_Id=${Id}`
      );

      if (result) {
        const base64PDF = result.data; // assuming result.data contains the base64 string
        // debugger;
        // Decode base64 string to binary string
        const binaryString = atob(base64PDF);

        // Convert binary string to Uint8Array
        const arrayBuffer = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          arrayBuffer[i] = binaryString.charCodeAt(i);
        }

        // Create Blob from Uint8Array
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });

        // Create URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element, set the href and download attributes
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `ticket${Id}.pdf`);

        // Append the link to the DOM and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link from the DOM
        document.body.removeChild(link);

        // Optionally, handle success messages
        toast.success("Ticket downloaded successfully!");
      }
    } catch (err) {
      // Handle errors if the API call fails
      toast.error("Failed to download ticket. Please try again later.");
      console.error("Error downloading ticket:", err);
    }
  };

  // useEffect(() => {
  //   const order = JSON.parse(localStorage.getItem("Order_Details"));

  //   console.log(order);

  //   setTicketDetails(order);
  //   setBibExpoDetails(order[0]);
  //   setParticipantId(order[0]?.Event_Booking_Participant_Id);
  // }, []);
  // useEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });

  //   // return () => {
  //   //   localStorage.removeItem("Order_Details");
  //   //   localStorage.removeItem("rzp_checkout_anon_id");
  //   //   localStorage.removeItem("rzp_device_id");
  //   // };
  // }, []);
  useEffect(() => {
    viewTicketHandle();
  }, []);

  return (
    <>
      {fetchingDetails && <PreLoader />}
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center font-inter fw-500 text-14 text-light-1">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      navigate("/dashboard/booking");
                    }}
                  >
                    Booking
                  </div>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Event Ticket</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pt-sm layout-pb-md">
        <div className="container">
          <button
            onClick={() => navigate("/event/list", { replace: true })}
            className="button -sm border-primary -primary-1 text-primary rounded-25 text-12 px-20 py-10 mt-20 mb-20"
          >
            Explore More Events
          </button>
        </div>
        <div className="container">
          {ticketDetails?.map((ticket) => {
            // var eventVenue = ticket?.Event_Venue;
            // var eventTime = ticket?.Event_Time;
            // var eventDate = ticket?.Event_Start_Date;
            // setParticipantId(ticket?.Event_Booking_Participant_Id);

            return (
              <div className="shadow-2 rounded-16 px-40 lg:px-20 py-40 lg:py-20 mb-25 relative">
                <div className="card">
                  <div className="row items-center justify-between">
                    <div className="col-lg-2 col-md-6">
                      <div
                        className="overflow-hidden"
                        style={{ height: "150px", width: "150px" }}
                      >
                        <img
                          src={`${MEDIA_URL}${ticket?.Image_Path}`}
                          className="h-full w-full rounded-100 object-cover"
                          alt="Event"
                        />
                      </div>
                    </div>
                    <div className="col-lg-7 items-start">
                      <h4 className="text-primary fw-700 text-27">
                        {ticket?.Event_Name}
                      </h4>
                      <div className="d-flex justify-between py-20 border-bottom-type-1 col-12 lg:flex-column">
                        {/* <div className="d-flex">
                          <div className="text-13 lh-12 text-primary">
                            Organizer
                          </div>
                          <div className="text-12 lh-12 fw-600 ml-10">
                            {ticket?.Org_Name}
                          </div>
                        </div> */}
                        {/* <div className="d-flex">
                          <div className="text-13 lh-12 text-primary">
                            Booking Date
                          </div>
                          <div className="text-12 lh-12 fw-600 ml-10">
                            {ticket?.Booking_Date}
                          </div>
                        </div> */}
                        <div className="d-flex col-md-4">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Event Date
                          </div>
                          <div className="text-12 font-inter lh-12 fw-600 ml-10">
                            {ticket?.Event_Start_Date}
                          </div>
                        </div>
                        <div className="d-flex col-md-4 lg:mt-5">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Event Time
                          </div>
                          <div className="text-12 font-inter lh-12 fw-600 ml-10">
                            {ticket?.Event_Time} Onwards
                          </div>
                        </div>
                        {ticket?.BIB_Number ? (
                          <div className="d-flex col-md-4 lg:mt-5">
                            <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                              Transaction Number
                            </div>
                            <div className="text-12 font-inter lh-12 fw-600 ml-10">
                              {ticket?.Transaction_Number}
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex col-md-4 lg:mt-5">
                            <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                              Transaction Number
                            </div>
                            <div className="text-12 font-inter lh-12 fw-600 ml-10">
                              {ticket?.Transaction_Number}
                            </div>
                          </div>
                        )}
                        {/* <div className="d-flex">
                      <div className="text-13 lh-12 text-primary">
                        BIB Number
                      </div>
                      <div className="text-12 lh-12 fw-600 ml-10">182</div>
                    </div> */}
                      </div>
                      <div className="d-flex justify-between py-20 border-bottom-type-1 col-12 lg:flex-column">
                        <div className="d-flex col-md-4">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Booking Date
                          </div>
                          <div className="text-12 font-inter lh-12 fw-600 ml-10">
                            {ticket?.Booking_Date}
                          </div>
                        </div>
                        <div className="d-flex col-md-4 lg:mt-5">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Booking Time
                          </div>
                          <div className="text-12 font-inter lh-12 fw-600 ml-10">
                            {ticket?.Booking_Time} Onwards
                          </div>
                        </div>

                        <div className="d-flex col-md-4 lg:mt-5">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Booking Id
                          </div>
                          <div className="text-12 font-inter lh-12 fw-600 ml-10">
                            {ticket?.Booking_Id}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-between py-20 lg:flex-column">
                        <div className="col-lg-2 col-md-6 border-right lg:border-none lg:d-flex word-break">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Name
                          </div>

                          <div className="text-12 font-inter lh-12 fw-600 mt-10 lg:mt-0 lg:ml-10 word-break">
                            {ticket?.First_Name} {ticket?.Last_Name}
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6 border-right lg:border-none lg:mt-5 lg:d-flex">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Ticket Price
                          </div>
                          {/* <div className="text-12 lh-12 fw-600 mt-10">Running</div> */}

                          <div className="text-12 font-inter lh-12 fw-600 mt-10 lg:mt-0 lg:ml-10">
                            ₹ {ticket?.Event_Price}
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6 border-right lg:border-none lg:mt-5 lg:d-flex">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Race Distance
                          </div>
                          {/* <div className="text-12 lh-12 fw-600 mt-10">
                        5K Climate Warriors
                      </div> */}
                          <div className="text-12 font-inter lh-12 fw-600 mt-10 lg:mt-0 lg:ml-10">
                            {ticket?.Event_Category_List}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 lg:mt-5 word-break">
                          <div className="text-13 font-inter fw-500 lh-12 text-primary w-100">
                            Venue
                          </div>

                          <div className="text-12 font-inter lh-12 fw-600 mt-10 lg:mt-5">
                            {ticket?.Event_Venue}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-6 rotate-270">
                      {ticket?.BIB_Number ? (
                        <>
                          <div
                            class="text-13 text-dark-1 fw-500 text-center"
                            style={{ top: "10px", position: "relative" }}
                          >
                            BIB Number
                          </div>
                          <div className="text-40 fw-500 font-inter text-primary text-center">
                            {/* <span class="text-13 text-dark-1 fw-500">BIB</span>{" "} */}
                            {ticket?.BIB_Number}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="border-primary-4 lg:d-none"></div>
                      {/* <img
                        src="https://upload.wikimedia.org/wikipedia/commons/5/5e/QR_Code_example.png"
                        alt="qr"
                        className="mt-10 d-block mx-auto"
                        style={{ width: "120px" }}
                      /> */}
                    </div>
                    <i
                      onClick={() =>
                        downloadTicket(ticket?.Event_Booking_Participant_Id)
                      }
                      className="fas col-auto px-0 faa-download text-20 fr dropdown__button d-flex justify-start rounded-4 text-primary text-14 download_ticket"
                    ></i>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="shadow-2 rounded-16 mt-25">
            <div className="px-40 lg:px-20 pt-40">
              <div
                className={`${
                  bibExpoDeatials?.Is_BIB_Expo_Available === 1
                    ? "border-bottom"
                    : ""
                }`}
              >
                <h4 className="fw-600 text-16 text-primary mb-10">
                  {" "}
                  Refund and Cancellation Policy
                </h4>
                <div
                  className="font-inter"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeAndModifyHTML(
                      ticketDetails[0]?.Refund_Cancellation
                    ),
                  }}
                ></div>{" "}
                {/* <ul className="text-10 mb-10" style={{ listStyleType: "disc" }}>
                  <li>
                    Lorem ipsum dolor sit amet consectetur. Libero lacus et eros
                    sed bibendum. Pellentesque pu
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur. Libero lacus et eros
                    sed bibendum. Pellentesque pu
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur. Libero lacus et eros
                    sed bibendum. Pellentesque pu
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur. Libero lacus et eros
                    sed bibendum. Pellentesque pu
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur. Libero lacus et eros
                    sed bibendum. Pellentesque pu
                  </li>
                </ul> */}
              </div>

              {isBibExpoAvail === 1 ? (
                <div className="col-12">
                  <h4 className="fw-600 text-16 text-primary mt-10 mb-10">
                    BIB Expo Details
                  </h4>
                  <>
                    <div className="d-flex lg:flex-column">
                      <div className="d-flex justify-between lg:flex-column col-lg-7">
                        <div className="col-lg-4">
                          <h4 className="fw-600 text-12 mt-10 mb-10">
                            Date & Time
                          </h4>
                          {dateAndTime &&
                            Array.isArray(dateAndTime) &&
                            dateAndTime.map((list, index) => (
                              <div
                                key={index}
                                className="text-10 font-inter py-1 lg:py-0 lh-12 fw-500"
                              >
                                {list?.BIB_Date}
                                {"  "}{" "}
                                <span className="ml-5 font-inter">
                                  {" "}
                                  Section :-{" "}
                                </span>
                                {list?.BIB_StartTime} To {list?.BIB_EndTime}
                              </div>
                            ))}
                        </div>
                        {/* <div>
                          <h4 className="fw-600 text-12 text-primary mt-10 mb-10">
                            Time
                          </h4>
                          <div className="text-11 lh-12 fw-500">
                            {bibExpoDeatials?.Event_Time}
                          </div>
                        </div> */}
                        <div className="col-lg-7">
                          <h4 className="fw-600 text-12 mt-10 mb-10">
                            BIB Expo Venue
                          </h4>
                          <div className="text-11 font-inter lh-12 fw-500">
                            {bibExpoDeatials?.Event_Venue}
                          </div>
                        </div>
                        <div className="border-right lg:border-none"></div>
                      </div>
                      <div className="d-flex flex-column lg:ml-0 flex-md-row align-items-end ml-10 ml-lg-0 col-md-5">
                        <div className="col-12 col-md-8 mb-2 mb-md-0">
                          <h4 className="fw-600 text-16 lg:mt-10">
                            <span className="text-primary">Email ID : </span>
                            {orgEmailId}
                          </h4>
                        </div>
                        <div className="d-flex justify-content-end lg:justify-start col-12 col-md-4">
                          <a
                            target="_blank"
                            href="https://www.linkedin.com/company/fitizenindia/"
                            className="fab fa-linkedin-in border-dark-1 lg:ml-0 lg:mt-0 text-5 fw-600 rounded-25 px-5 py-10 text-center cursor-pointer h-20 w-20 mt-18 ml-10 button text-size-ticket"
                            rel="noreferrer"
                          />
                          <a
                            target="_blank"
                            href="https://www.facebook.com/FitizenIndia?mibextid=LQQJ4d"
                            className="fab fa-facebook-f border-dark-1 text-5 lg:mt-0 fw-600 rounded-25 px-5 py-10 text-center cursor-pointer h-20 w-20 mt-18 ml-10 button text-size-ticket"
                            rel="noreferrer"
                          />
                          <a
                            target="_blank"
                            href="https://www.instagram.com/fitizenindia?igsh=dHVzamRwNzZzOXFz&utm_source=qr"
                            className="fab fa-instagram border-dark-1 text-5 lg:mt-0 fw-600 rounded-25 px-5 py-10 text-center cursor-pointer h-20 w-20 mt-18 ml-10 button text-size-ticket"
                            rel="noreferrer"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="row pb-40 pt-10">
              <div className="col-lg-12">
                <div className="border-primary-4 w-full"></div>
                <div className="px-40 pt-10">
                  {/* <p className="text-10 lh-12">
                    <span className="text-primary fw-500">Note : </span> Lorem
                    ipsum dolor sit amet consectetur. Libero lacus et eros sed
                    bibendum. Pellentesque pu Lorem ipsum dolor sit amet
                    consectetur. Libero lacus et eros sed bibendum. Pellentesque
                    pu Lorem ipsum dolor sit amet consectetur. Libero lacus et
                    eros sed bibendum. Pellentesque pu
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ViewTickets;
